import React, { forwardRef, MouseEventHandler } from 'react';
import clsx from 'clsx';
import { MessageInputControlType } from './hooks/useMessageInputCompositionControls';
import SentimentSatisfiedAltOutlinedIcon from '@mui/icons-material/SentimentSatisfiedAltOutlined';
import FormatBoldIcon from '@mui/icons-material/FormatBold';
import FormatItalicIcon from '@mui/icons-material/FormatItalic';
import StrikethroughSIcon from '@mui/icons-material/StrikethroughS';
import CodeIcon from '@mui/icons-material/Code';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import AddCardIcon from '@mui/icons-material/AddCard';

type MessageInputControlButtonProps = {
  onClick: MouseEventHandler<HTMLButtonElement>;
  type: MessageInputControlType;
  active?: boolean;
};

const EmojiIcon = () => (
  <SentimentSatisfiedAltOutlinedIcon style={{ fontSize: '1.3rem' }} />
);

const BoldIcon = () => (
  <FormatBoldIcon />
);

const CodeSnippetIcon = () => (
  <CodeIcon />
);

const ItalicsIcon = () => (
  <FormatItalicIcon />
);

const StrikeThroughIcon = () => (
  <StrikethroughSIcon />
);

const AttachmentIcon = () => (
  <AttachFileIcon />
);

const TapcardIcon = () => (
  <AddCardIcon />
)

const ControlsIcons: Record<MessageInputControlType, React.ComponentType> = {
  bold: BoldIcon,
  code: CodeSnippetIcon,
  emoji: EmojiIcon,
  italics: ItalicsIcon,
  attachment: AttachmentIcon,
  tapcard: TapcardIcon,
  'strike-through': StrikeThroughIcon,
};


export const MessageInputControlButton = forwardRef<HTMLButtonElement, MessageInputControlButtonProps>((
  { active, onClick, type }, ref,
) => {
  const Icon = ControlsIcons[type];

  if (!Icon) return null;

  return (
    <button className={clsx('message-input__controls-button', type, { 'active': active })} onClick={onClick} ref={ref}>
      <Icon />
    </button>
  );
});
